import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Select from 'react-select';
import PropTypes from 'prop-types';

/**
 * for this page
 */

const GwSearch = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            handlePlace: PropTypes.func,
            handleType: PropTypes.func,
            handleCategory: PropTypes.func,
            locations: PropTypes.array,
            zhinengList: PropTypes.array,
        };

        handlePlaceChange = place => {
            this.props.handlePlace(place.value);
        };
        handleTypeChange = type => {
            this.props.handleType(type.value);
        };
        handleCategoryChange = category => {
            this.props.handleCategory(category.value);
        };
        render() {
            const { locations, zhinengList } = this.props;
            const typeOptions = [
                { value: '不限', label: '不限' },
                { value: 'ff80808164b22a300164d4415a470087', label: '正式' },
                { value: 'ff80808164b22a300164d4415a470088', label: '实习' },
            ];
            // const placeOptions = [
            //     { value: '不限', label: '不限' },
            //     { value: '北京', label: '北京' },
            //     { value: '上海', label: '上海' },
            //     { value: '南京', label: '南京' },
            //     { value: '成都', label: '成都' },
            //     { value: '广州', label: '广州' },
            //     { value: '深圳', label: '深圳' },
            //     { value: '杭州', label: '杭州' },
            //     { value: '武汉', label: '武汉' },
            //     { value: '重庆', label: '重庆' },
            //     { value: '天津', label: '天津' },
            //     { value: '苏州', label: '苏州' },
            //     { value: '西安', label: '西安' },
            //     { value: '长沙', label: '长沙' },
            //     { value: '沈阳', label: '沈阳' },
            //     { value: '青岛', label: '青岛' },
            //     { value: '郑州', label: '郑州' },
            //     { value: '杭州', label: '杭州' },
            //     { value: '大连', label: '大连' },
            //     { value: '东菀', label: '东菀' },
            //     { value: '宁波', label: '宁波' },
            //     { value: '济南', label: '济南' },
            // ];

            // const categoryOptions = [
            //     { value: '不限', label: '不限' },
            //     { value: '2c9e47a26a0c3795016a1fce76031a05', label: '产品技术族' },
            //     { value: '2c9e47a26a0c3795016a1fce76031a08', label: '市场营销族' },
            //     { value: '2c9e47a26a0c3795016a1fce76031a09', label: '项目族' },
            //     { value: '2c9e47a26a0c3795016a1fce76031a0a', label: '职能族' },
            //     { value: '2c9e47a26a0c3795016a1fce76031a07', label: '设计族' },
            //     { value: '2c9e47a26a0c3795016a1fce76031a06', label: '内容族' },
            // ];

            // const { handleDepart, handlePlace, handleType } = this.props;
            // const { depart, place, type } = this.state;
            // console.log('depart==', depart);

            return (
                <div className={styles.search_sh}>
                    <div className={styles.col_w1000}>
                        <ul className={styles.search_list}>
                            {/* <li style={{ display: 'none' }}>
                                <span className={styles.lei}>工作性质</span>
                                <div className={styles.vertical}>
                                    <Select
                                        options={typeOptions}
                                        placeholder="不限"
                                        className={styles.searchSelect1}
                                        onChange={this.handleTypeChange}
                                    />
                                </div>
                            </li> */}
                            <li>
                                <span className={styles.lei}>工作地点</span>
                                <div className={styles.vertical}>
                                    <Select
                                        options={locations}
                                        placeholder="请选择"
                                        className={styles.searchSelect1}
                                        onChange={this.handlePlaceChange}
                                    />
                                </div>
                            </li>
                            <li>
                                <span className={styles.lei}>岗位类型</span>
                                <div className={styles.vertical}>
                                    <Select
                                        options={zhinengList}
                                        placeholder="请选择"
                                        className={styles.searchSelect1}
                                        onChange={this.handleCategoryChange}
                                    />
                                </div>
                            </li>
                            <div style={{ clear: 'both' }} />
                        </ul>
                    </div>
                </div>
            );
        }
    },
);

export { GwSearch };
export default GwSearch;
